module.exports = __webpack_public_path__ + "static/media/fruits_27.dcbd0ad2.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/fruits/fruits_27.csv
// module id = 692
// module chunks = 0